import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { environment } from "environments/environment";
import { SupplierClassification } from "@common/models/supplier-classification";
import { Status } from "@common/models";

@Injectable({ providedIn: "root" })
export class SupplierClassificationService {
  constructor(private _http: HttpClient) {}

  getAll():Observable<SupplierClassification[]> { 
    

    return this._http.get<SupplierClassification[]>(
      `${environment.commonApiUrl}/api/supplier-classification`
    );
  }

  getById(id: number) {
    return this._http.get<SupplierClassification>(`${environment.commonApiUrl}/api/supplier-classification/${id}`);
  }

  addSupplierClassification(supplierClassification){
    return this._http.post<SupplierClassification>(`${environment.commonApiUrl}/api/supplier-classification`, supplierClassification).pipe(
      map((response: any) => response.supplierClassification as SupplierClassification),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editSupplierClassification(supplierClassification){
    return this._http.put<SupplierClassification>(`${environment.commonApiUrl}/api/supplier-classification/${supplierClassification.id}`, supplierClassification).pipe(
      map((response: any) => response.supplierClassification as SupplierClassification),
      catchError(e => {
        return throwError(e);
      })
    );
  }

}
